import React from 'react'

export default function Hsec2() {
  return (
    <section className='mb-2'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>
                    <div>
                        <h3>Strategic Aims</h3>
                        <p>This strategy will guide Antigua and Barbuda’s efforts to effectively address the issue of invasive alien species to protect our natural heritage and our people’s livelihoods by: 
                        </p>

                        <ul>
                            <li>Preventing new invasive or potentially invasive species, fromarriving and establishing on the islands. </li>
                            <li>Taking action against existing priority invasive species at priority sites.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
